import React, { useState } from "react";
import { Grid, makeStyles, Tab, Tabs, GridList, GridListTile, Hidden } from "@material-ui/core";
import { Typography, Page } from "@packages/ui";
import _ from "lodash";
import Lightbox from "react-image-lightbox";
import UploadRentalPhotoPrompt from "../../components/UploadRentalPhoto/Prompt";
import { useCurrentRental } from "../../hooks/rentalHooks";
import PreviousPhotoBatch from "./PreviousPhotoBatch";
//import Carousel from 'react-material-ui-carousel';



const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 15,
    paddingBottom: theme.spacing(3),
  },
  tab: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
  },
  tabs: {
    borderRight: `0px solid ${theme.palette.divider}`,
    width: '70vw',
  },

}));

const getLightboxPhotos = (preRentalPhotos, displayPhotos, customerPhotos) => {
  //const staffPhotoURLs = staffPhotos.map(({ photo_urls }) => photo_urls).flat();
  const customerPhotoURLs = customerPhotos.map(({ photo_urls }) => photo_urls).flat();
  return preRentalPhotos.concat(displayPhotos, customerPhotoURLs);
};

const splitRentalPhotosStack = (allRentalPhotos) =>
  allRentalPhotos.reduce(
    (accumulator, batch) => {
      const { batch_type } = batch;
      if (batch_type === "STAFF") {
        accumulator.staffPhotos.push(batch);
        return accumulator;
      }
      accumulator.customerPhotos.push(batch);
      return accumulator;
    },
    { staffPhotos: [], customerPhotos: [] }
  );

const RentalPhotos = () => {
  const classes = useStyles();
  const currentRental = useCurrentRental();
  const preRentalPhotos = _.get(currentRental, "pre_rental_photos", []);
  const allRentalPhotos = _.get(currentRental, "rental_photos", []);
  const { staffPhotos, customerPhotos } = splitRentalPhotosStack(allRentalPhotos);


  const ifStaffPhotos = staffPhotos.filter(function (o) {
    return o.hasOwnProperty('photo_urls');
  }).length > 0;

  let displayPhotos = []
  if (ifStaffPhotos) {
    displayPhotos = staffPhotos.filter(record => {
      if (record?.photo_urls?.length > 5) {
        return record.photo_urls
      }
      return record.photo_urls
    })
  }

  const lastPhotosDisplay = _.get(_.last(displayPhotos), 'photo_urls', [])



  const lightBoxPhotos = getLightboxPhotos(preRentalPhotos, lastPhotosDisplay, customerPhotos);

  const [lightbox, setLightbox] = useState({ photoIndex: 0, isOpen: false });
  const [value, setValue] = useState(0);

  const handleOpenLightbox = (photoUrl) => {
    const lightBoxIndex = lightBoxPhotos.findIndex((url) => url == photoUrl);
    setLightbox({ photoIndex: lightBoxIndex, isOpen: true });
  };
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }


  return (
    <Page className={classes.root} title="Rental Photos - My Journey Portal">
      <Grid container lg={10} sm={6} xl={3} xs={12}>
        <div>
          <Typography variant={"h1"} style={{ marginBottom: 30 }}>
            Rental Photos
          </Typography>
          {preRentalPhotos.length > 5 || lastPhotosDisplay.length > 5 ? (
            <>
              <Typography paragraph>
                <strong>
                  Below are the rental photos of your rental vehicle with rental agreement number{" "}
                  {currentRental?.rental_agreement_number}.
                </strong>
              </Typography>
              <Typography paragraph>
                These are the most recent photos of the vehicle. Although every effort has been made
                to ensure these photos reflect the vehicle&apos;s current condition at the time of
                pick up, we encourage you to check the vehicle before you drive away.
              </Typography>
              <UploadRentalPhotoPrompt />
              <Typography variant="h2" paragraph style={{ marginTop: 30, marginBottom: 30 }}>
                Our Photos
              </Typography>
              <Hidden mdDown>
                <div className={classes.tab}>
                  <Tabs md={12}
                    orientation="horizantal"
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    aria-label="Rental Photos"
                    className={classes.tabs}
                  >
                    {preRentalPhotos.length > 5 ? preRentalPhotos.map((photoUrl, index) => {
                      const onClick = () => handleOpenLightbox(photoUrl);

                      return (
                        <Tab key={index} lg={3} sm={6} xl={3} xs={12}
                          label={
                            <a
                              onClick={onClick}
                              style={{ display: "inline", cursor: "pointer" }}
                              value={index}
                            >
                              <img key={index} name={index} src={photoUrl} height="70%" width="70%" style={{ display: 'block' }} />
                            </a>}>
                        </Tab>
                      );
                    }) : lastPhotosDisplay.length > 5 ? lastPhotosDisplay.map((photoUrl, index) => {
                      const onClick = () => handleOpenLightbox(photoUrl);

                      return (
                        <Tab key={index} lg={3} sm={6} xl={3} xs={12}
                          label={
                            <a
                              onClick={onClick}
                              style={{ display: "inline", cursor: "pointer" }}
                              value={index}
                            >
                              <img key={index} name={index} src={photoUrl} height="70%" width="70%" style={{ display: 'block' }} />
                            </a>}>
                        </Tab>
                      );
                    }) : ""}
                  </Tabs>
                </div>
              </Hidden>
              <Hidden lgUp>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>

                  <GridList style={{ flexWrap: 'nowrap', transform: 'translateZ(0)' }} md={12} spacing={2} cols={3.5} cellHeight={100}>
                    {preRentalPhotos.length > 5 ? preRentalPhotos.map((photoUrl, index) => {
                      const onClick = () => handleOpenLightbox(photoUrl);

                      return (

                        <GridListTile key={index} item lg={3} sm={6} xl={3} xs={12}>
                          <a
                            onClick={onClick}
                            style={{ display: "inline", cursor: "pointer" }}
                            value={index}
                          >
                            <img key={index} name={index} src={photoUrl} width="80%" height="120%" style={{ display: 'block' }} />
                          </a>
                        </GridListTile>
                      );
                    }) : lastPhotosDisplay.length > 5 ? lastPhotosDisplay.map((photoUrl, index) => {
                      const onClick = () => handleOpenLightbox(photoUrl);

                      return (

                        <GridListTile key={index} item lg={3} sm={6} xl={3} xs={12}>
                          <a
                            onClick={onClick}
                            style={{ display: "inline", cursor: "pointer" }}
                            value={index}
                          >
                            <img key={index} name={index} src={photoUrl} width="80%" height="120%" style={{ display: 'block' }} />
                          </a>
                        </GridListTile>
                      );

                    }) : ""}
                  </GridList>
                </div>
              </Hidden>
            </>
          ) : (
            <>
              <Typography paragraph>
                We’re sorry, there are no pre-rental photos available for your rental vehicle with rental agreement number{" "}
                {currentRental?.rental_agreement_number}.
              </Typography>
              <Typography paragraph>
                We encourage you to check the vehicle for existing damage before you drive away.
              </Typography>
              <UploadRentalPhotoPrompt />
            </>
          )}
          {/* {staffPhotos.length > 0 && (
            <>
              <Typography variant="h2" paragraph style={{ marginTop: 30, marginBottom: 30 }}>
                Previous Staff Photos
              </Typography>
              {staffPhotos.map((batch) => (
                <PreviousPhotoBatch
                  key={batch.batch_id}
                  handleOpenLightbox={handleOpenLightbox}
                  {...batch}
                />
              ))}
            </>
          )} */}
          {customerPhotos?.length > 0 && (
            <>
              <Typography variant="h2" paragraph style={{ marginTop: 30, marginBottom: 30 }}>
                Your Photos
              </Typography>
              <div>
                {customerPhotos.map((batch) => (
                  <PreviousPhotoBatch
                    key={batch.batch_id}
                    handleOpenLightbox={handleOpenLightbox}
                    {...batch}
                  />
                ))}
              </div>

            </>
          )}
          {lightbox.isOpen && (
            <Lightbox
              mainSrc={lightBoxPhotos[lightbox.photoIndex]}
              nextSrc={lightBoxPhotos[(lightbox.photoIndex + 1) % lightBoxPhotos.length]}
              prevSrc={
                lightBoxPhotos[
                (lightbox.photoIndex + lightBoxPhotos.length - 1) % lightBoxPhotos.length
                ]
              }
              onCloseRequest={() => setLightbox({ photoIndex: 0, isOpen: false })}
              onMovePrevRequest={() =>
                setLightbox({
                  photoIndex:
                    (lightbox.photoIndex + lightBoxPhotos.length - 1) % lightBoxPhotos.length,
                  isOpen: true,
                })
              }
              onMoveNextRequest={() =>
                setLightbox({
                  photoIndex: (lightbox.photoIndex + 1) % lightBoxPhotos.length,
                  isOpen: true,
                })
              }
              reactModalStyle={{ zIndex: 2000 }}
            />
          )}
        </div>
      </Grid>
    </Page>
  );
};

export default RentalPhotos;
